import { render, staticRenderFns } from "./DoctorFilters.vue?vue&type=template&id=7ac598d4&"
import script from "./DoctorFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ac598d4')) {
      api.createRecord('7ac598d4', component.options)
    } else {
      api.reload('7ac598d4', component.options)
    }
    module.hot.accept("./DoctorFilters.vue?vue&type=template&id=7ac598d4&", function () {
      api.rerender('7ac598d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/DoctorFilters.vue"
export default component.exports